var map = {
	"./arrow-down-blue.svg": 480,
	"./arrow-down-grey.svg": 481,
	"./arrow-right-white.png": 482,
	"./arrow-right.svg": 483,
	"./big_unicorn.png": 196,
	"./blue-loader.svg": 61,
	"./circle-grey.svg": 484,
	"./circle.svg": 485,
	"./coinbaseWalletIcon.svg": 125,
	"./dropdown-blue.svg": 486,
	"./dropdown.svg": 487,
	"./dropup-blue.svg": 488,
	"./eth-logo.png": 489,
	"./ethereum-logo.png": 205,
	"./fortmaticIcon.png": 126,
	"./link.svg": 490,
	"./logo-black.png": 202,
	"./logo-white.png": 203,
	"./magnifying-glass.svg": 491,
	"./menu.svg": 492,
	"./metamask.png": 204,
	"./noise.png": 198,
	"./plus-blue.svg": 493,
	"./plus-grey.svg": 494,
	"./portisIcon.png": 127,
	"./question-mark.svg": 495,
	"./question.svg": 496,
	"./spinner.svg": 497,
	"./token-list/lists-dark.png": 498,
	"./token-list/lists-light.png": 499,
	"./token-logo.png": 77,
	"./trustWallet.png": 500,
	"./uniswap-token-logo.png": 501,
	"./walletConnectIcon.svg": 128,
	"./x.svg": 502,
	"./xl_uni.png": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;